<template lang="pug">
  .wrapper(data-aos="fade-right")
    .path(:class="{ 'path--selected': isSelected }")
      .mr-2
        span.path__name(v-line-clamp="isSelected ? 0 : 1") {{ category.title }}
        
      v-icon.path__icon(color="#FFFFFF") {{ isSelected ? 'menu_open' : 'keyboard_arrow_right'}}
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'knowledgebase-explorer-path',

  props: {
    category: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('knowledgeBase', ['filter']),

    isSelected () {
      return (this.filter.category && this.filter.category.id == this.category.id)
    },

  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #757575;
  margin-bottom: 1px;

  &:hover {
    background: transparentize($color: #C4C4C4, $amount: 0.5);
  }
}

.path {
  padding: 16px 8px 16px 16px;
  transition: .3s all ease;

  display: flex;
  justify-content: space-between;
  
  line-height: 20px;

  &__name {
    word-wrap: break-word;
  }
  
  &__files { 
    font-size: 12px;
    color: #C4C4C4;
  }

  &__icon {
    font-weight: inherit;
  }

  &--selected {
    border-left: 12px solid #00BCD4;
  }
}
</style>